import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestGuard = ({ children }) => {
  const { isAuthenticated, isInitialised, role } = useAuth();
  if (isInitialised && isAuthenticated) {
    const redirectPath = "/home";
    return <Navigate to={redirectPath} replace />;
  }
  return <>{children}</>;
};

export default GuestGuard;
